import { format, isValid } from 'date-fns';

const formatingCreatedAt = (createdAt: string): string => 
  isValid(new Date(createdAt)) ? format(new Date(createdAt), 'dd.MM.yyyy') : createdAt;

export { formatingCreatedAt };
